import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=388aa3f4&scoped=true&"
import script from "./Mine.vue?vue&type=script&lang=js&"
export * from "./Mine.vue?vue&type=script&lang=js&"
import style0 from "./Mine.vue?vue&type=style&index=0&id=388aa3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388aa3f4",
  null
  
)

export default component.exports